var data = {
	"body": "<g fill=\"none\"><circle cx=\"12\" cy=\"12\" r=\"10\" fill=\"currentColor\"/></g>",
	"width": 24,
	"height": 24
};
export default data;
